/** 管理后台前端路由前缀（非后端 API 路径） */
export const ADMIN_BASE_PATH = '/lvxinManage'

export function isAdminRoute(path) {
  const p = String(path || '')
  return p === ADMIN_BASE_PATH || p.startsWith(`${ADMIN_BASE_PATH}/`)
}

export function adminPath(sub = '') {
  const s = String(sub || '').replace(/^\//, '')
  return s ? `${ADMIN_BASE_PATH}/${s}` : ADMIN_BASE_PATH
}
